import { RightArrowIcon, TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { CareerDetailsProps } from './types';

const CareerDetails = ({
  clearDetails,
  department,
  details,
}: CareerDetailsProps) => {
  const t = useTranslations();

  return (
    <div className="py-8" data-cy="career-details">
      <button onClick={clearDetails} className="mb-8 text-slate-200">
        &larr; {t('back_to_list')}
      </button>
      <div className="pb-4">
        <TypographyV3 Element="h4" variant="h5" weight="light">
          {department} - {t('open_roles')}
        </TypographyV3>
      </div>
      <div className="divide-y divide-sandstone-500 border-t-2 border-b border-sandstone-500">
        {details.map((job) => (
          <a
            key={job.url}
            href={job.url}
            target="_blank"
            className={cx(
              'relative block w-full py-6 text-left text-sandstone-500',
              'border-r-0 border-l-0 border-solid border-transparent',
              'flex items-center justify-between',
            )}
            rel="noreferrer"
          >
            <div>
              <TypographyV3
                Element="h5"
                className="text-[1.375rem] lg:text-heading-lg"
                weight="light"
              >
                {job.title}
              </TypographyV3>
              <TypographyV3 variant="body-small" className="mt-2">
                {job.city} {job.city && job.country && `-`} {job.country}
              </TypographyV3>
            </div>
            <RightArrowIcon />
          </a>
        ))}
      </div>
    </div>
  );
};

export default CareerDetails;
